import { apiList, $axios } from '@/api'

export default {
    actions: {
        getBooksByCourse(_, payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.books.getBooks.method,
                    params: {
                        wsfunction: apiList.books.getBooks.moodle_method
                    },
                    data: {
                        courseids: [payload]
                    }
                })
                    .then(resp => {
                        resolve(resp)
                    }).catch(err => reject(err))
            })
        },
        viewBook(_, payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.books.getBooks.method,
                    params: {
                        wsfunction: apiList.books.getBooks.moodle_method,
                        courseids: [payload]
                    }
                })
                    .then(resp => {
                        resolve(resp)
                    }).catch(err => reject(err))
            })
        }
    }
}
